export default {
  name: 'accountOrderTabs',
  component: () => ({
    activeTab: 'online',
    
    init() {
      // Initialize the component and check URL parameters
      // console.log('Account Order Tabs initialized');
      this.setTabFromURL();
      
      // Listen for URL changes (back/forward browser navigation)
      window.addEventListener('popstate', () => {
        this.setTabFromURL();
      });
    },

    setTabFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      const tabParam = urlParams.get('tab');
      
      // Set active tab based on URL parameter
      if (tabParam === 'full-transaction' || tabParam === 'fullTransaction') {
        this.activeTab = 'fullTransaction';
      } else {
        this.activeTab = 'online';
      }
    },

    setActiveTab(tab) {
      this.activeTab = tab;
      
      // Update URL without page reload
      const url = new URL(window.location);
      if (tab === 'fullTransaction') {
        url.searchParams.set('tab', 'full-transaction');
      } else {
        url.searchParams.delete('tab'); // Remove tab param for online (default)
      }
      
      window.history.pushState({}, '', url);
    },

    isActiveTab(tab) {
      return this.activeTab === tab;
    },

    getTabClass(tab) {
      return this.isActiveTab(tab) 
        ? 'border-[#54565A] font-medium text-black' 
        : 'border-transparent text-[#99A8B2] hover:text-black';
    }
  })
}